import { Injectable } from "@angular/core";
import { AbstractControl } from '@angular/forms';
import { FormControl, FormGroup, FormArray } from "@angular/forms";
import { ApiService } from "../api.service";


@Injectable()

export class mainCampaignServices {


    constructor(private apiService: ApiService) { }

    ValidateListCheckbox(control: AbstractControl) {
        var hasCheckbox = false;
        (<any>control).controls.forEach(function (value, key) {
            if (value.value.selected) {
                hasCheckbox = true;
            }
        });
        if (hasCheckbox) {
            return null;
        } else {
            return {
                error: true
            };
        }
    }

    getJSONCountries() {
        return this.apiService.getJSONCountries();
    }

    submitApplication(value: any) {
        return this.apiService.submitApplication(value);
    }

    searchPhone(data: any) {
        return this.apiService.searchPhone(data);
    }

    getListPhoneNumber(data: any) {
        return this.apiService.getListPhoneNumber(data);
    }
    updateStatusPhoneNumber(value: any) {
        return this.apiService.updateStatusPhoneNumber(value);
    }
    updateStatusPhoneNumberRollback(value: any) {
        return this.apiService.updateStatusPhoneNumberRollback(value);
    }

    getListNetwork() {
        return this.apiService.getListNetwork();
    }

    requestTAC(data: any) {
        return this.apiService.requestTAC(data);
    }
    verifyTAC(data: any) {
        return this.apiService.verifyTAC(data);
    }
}